import React, { useEffect, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import cross from "../../../../assets/images/cross.svg";
import memberAdded from "../../../../assets/images/memberAdded.png";
import tradeBellPng from "../../../../assets/images/bellIcon.svg";
import BubbleSvgButton from "../../CommonComponents/BubbleSvgButton/BubbleSvgButton";
// import "./PayoutSetupModal.css";
import FloatingTextFiled from "../../CommonComponents/FloatingTextFiled/FloatingTextFiled";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { useSelector } from "react-redux";

const VerificationApiModal = ({
  showDisConnectPopup = {},
  showEmailPopUp = {},
  setShowEmailPopUp,
  onClose,
  disConnectYesAction,
  callApi,
}) => {
  const [otp, setOtp] = useState("");
  const [codeIncorrect, setCodeIncorrect] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showLoadingPopUp, setShowLoadingPopUp] = useState(false);
  const [showSuccessPopUp, setShowSuccessPopUp] = useState(false);
  const [genericText, setGenericText] = useState("");
  const user=useSelector(state=>state?.user?.user);
  const api = useApi();

  // Check if any state is true to show the modal
  const shouldShowModal =
    showDisConnectPopup?.show ||
    showEmailPopUp?.show ||
    showLoadingPopUp ||
    showSuccessPopUp;

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
    setShowLoadingPopUp(false);
    setShowSuccessPopUp(false);
    setGenericText("");
  };

  const handleSendCode = async () => {
    setIsLoading(true);

    const response = await api("post", "users/updateAccountOTP");

    if (response?.status) setIsLoading(false);
  };

  const handleVerify = async () => {
    if (!otp || otp.length < 6) {
      setCodeIncorrect(true);
    } else {
      const response = await api("post", "users/verifyAccountOTP", {
        otp,
      });

      if (response?.data?.verified) {
        setShowEmailPopUp({ show: false });
        setShowLoadingPopUp(true);

        setTimeout(() => {
          callApi();
          setShowLoadingPopUp(false);
          setCodeIncorrect(false);
          setShowSuccessPopUp(true);
        }, 5000);
      } else {
        setCodeIncorrect(true);
      }
    }
  };

  const handleOtpChange = (e) => {
    setOtp(e.target.value);
    setCodeIncorrect(false); // Reset error when user types
  };

  useEffect(() => {
    setOtp("");
    setCodeIncorrect(false);
    if (showEmailPopUp?.show) {
      handleSendCode();
    }
  }, [showEmailPopUp?.show]);

  useEffect(() => {
    if (otp?.length === 6) {
      handleVerify();
    }
  }, [otp]);

  useEffect(() => {
    if (showDisConnectPopup?.show) {
      setGenericText(showDisConnectPopup?.buttonClick?.toLowerCase());
    }
  }, [showDisConnectPopup]);

  function toVerbIng(text) {
    if (!text) return "";
    const capitalized = text.charAt(0).toUpperCase() + text.slice(1);

    // Handle specific cases for proper spelling
    if (capitalized === "Delete") {
      return "Deleting";
    } else if (capitalized === "Disconnect") {
      return "Disconnecting";
    }

    return capitalized + "ing";
  }

  function toThirldVerb(text) {
    if (!text) return "";
    const capitalized = text.charAt(0).toUpperCase() + text.slice(1);

    // Handle specific cases for proper spelling
    if (capitalized === "Delete") {
      return "deleted";
    } else if (capitalized === "Disconnect") {
      return "disconnected";
    }

    return capitalized + "ing";
  }

  return (
    <div className="VerificationApiModalWrapper">
      {/* backdrop="false" was preventing click-outside-to-close; removed to restore default behaviour */}
      <Modal id="verificationApiModal" show={shouldShowModal} onHide={handleClose}>
        <Modal.Body>
          <div className="modalContent">
            <Button className="closeBtn" onClick={handleClose}>
              <img alt="Close Modal" src={cross} />
            </Button>

            {showLoadingPopUp && (
              <div className="regBox loadingWrap">
                <div className="loading-4">
                  <span className="span1"></span>
                  <span className="span2"></span>
                  <span className="span3"></span>
                </div>
                <p className="redirectingText">
                  <span className="exchangeDeletingText">{`${toVerbIng(
                    genericText
                  )} Exchange `}</span>
                  <br />
                  Please hold…
                </p>
              </div>
            )}

            {showSuccessPopUp && (
              <div className="regBox success">
                <div className="img-box">
                  <img alt="Success" src={memberAdded} />
                </div>
                <div className="content-box">
                  <p className="popUpMsg">
                    {`Exchange API key ${toThirldVerb(genericText)}!`}
                    <br />
                    <span>{user?.role==="leader"?"Reconnect to resume verifying your performance.":"Reconnect to resume your copy trading."}</span>
                  </p>
                </div>
              </div>
            )}

            {showEmailPopUp?.show && (
              <div className="regBox apiVerification">
                <div className="content-box">
                  <p className="popUpMsg text-center">
                    Please verify changes
                    <br />
                    <span>Use the code sent to your email</span>
                  </p>
                </div>
                <FloatingTextFiled
                  className={`apiVerificationInput w-100`}
                  forLabel="codeinput"
                  id="codeinput"
                  label="Enter code here"
                  placeholder="Enter code here"
                  value={otp}
                  onChange={handleOtpChange}
                  maxLength={6}
                />
                {codeIncorrect && (
                  <p
                    className="text-danger"
                    style={{
                      fontSize: "14px",
                      marginTop: "8px",
                      textAlign: "center",
                    }}
                  >
                    Code incorrect
                  </p>
                )}
                {/* <div style={{ textAlign: "center", marginTop: "12px" }}>
                  <button
                    style={{
                      background: "none",
                      border: "none",
                      color: "#007bff",
                      textDecoration: "underline",
                      cursor: "pointer",
                      fontSize: "14px",
                    }}
                    onClick={() => {
                      if (isLoading) return;
                      handleSendCode();
                    }}
                    disabled={isLoading}
                  >
                    Resend Code
                  </button>
                </div> */}
              </div>
            )}
            {showDisConnectPopup?.show && (
              <>
                <div className="regBox" style={{ gap: "13px" }}>
                  <div className="img-box">
                    <img
                      alt="Success"
                      src={tradeBellPng}
                      className="bellIconSvg"
                    />
                  </div>
                  <div className="content-box">
                    <p className="popUpMsg">
                      {showDisConnectPopup?.buttonClick === "Disconnect"
                        ? showDisConnectPopup?.type === "social"
                          ? "Disconnecting will stop auto sharing your trades to this channel"
                          : "Disconnecting your API keys will interrupt your service"
                        : showDisConnectPopup?.buttonClick === "Cancel"
                        ? "Cancel your subscription?"
                        : `${
                            genericText === "delete" ? "Delete" : genericText
                          } your API keys?`}
                      <br />
                      {showDisConnectPopup?.buttonClick === "Cancel" && (
                        <span>Copy trading will be interrupted.</span>
                      )}
                      {showDisConnectPopup?.buttonClick !== "Disconnect" &&
                        showDisConnectPopup?.buttonClick !== "Cancel" && (
                          <span>
                            All member trades will be closed if you continue.
                          </span>
                        )}
                    </p>
                  </div>
                </div>
                <div className="payoutButtonBox">
                  <BubbleSvgButton
                    className="payoutModalBtn"
                    mainDivStyle={{ width: "126px", height: "36px" }}
                    text={"Continue"}
                    type="button"
                    variant="black"
                    containerStyling={{
                      justifyContent: "center",
                    }}
                    onClick={disConnectYesAction}
                  />
                  <BubbleSvgButton
                    className="payoutModalBtn"
                    mainDivStyle={{ width: "126px", height: "36px" }}
                    text={"Cancel"}
                    type="button"
                    variant="red"
                    containerStyling={{
                      justifyContent: "center",
                    }}
                    onClick={handleClose}
                  />
                </div>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default VerificationApiModal;
